
import { Component, Prop, Ref, Vue, Watch } from 'vue-property-decorator';
import GeneratorList from './GeneratorList.vue';

@Component({
    components: { GeneratorList },
})
export default class GeneratorChooser extends Vue {

    @Prop({ required: false, default: () => [] })
    public readonly selected!: string[];

    @Prop({ required: false, default: undefined })
    public readonly portfolioKey!: string|undefined;

    @Prop({ required: false, default: undefined })
    public readonly whitelist!: string[]|undefined;

    @Prop({ required: false, default: undefined })
    public readonly blacklist!: string[]|undefined;

    @Prop({ required: false, default: undefined })
    public readonly maxSelectable!: number|undefined;

    @Prop({ required: false, default: false })
    public readonly directUpdate!: boolean;

    @Prop({ required: false, default: true })
    public readonly multiSelection!: boolean;

    @Prop({ required: false, default: false })
    public readonly removeAction!: boolean;

    @Ref('filterinput')
    private readonly filterinput: HTMLInputElement|undefined;

    private totalCount: number = -1;
    private count: number = -1;
    private selectedMutable: string[] = [];
    private filter: string = '';

    public created(): void {
        this.updateSelected();
    }

    @Watch('count')
    private onCountChanged() {
        if (this.totalCount === -1) {
            this.totalCount = this.count;
            this.$nextTick(() => this.filterinput?.focus());
        }
    }

    @Watch('selected')
    private updateSelected(): void {
        this.selectedMutable = [...this.selected];
    }

    private onSelectionChanged(selected: string[]): void {
        if (this.directUpdate) {
            this.$emit('update:selected', selected);
        } else {
            this.selectedMutable = selected;
        }
    }

    private submit(): void {
        this.$emit('submit', this.selectedMutable);
    }

    private cancel(): void {
        this.$emit('cancel');
    }
}
